const isNonNegativeNumber = (value, message = true) => {
  if (0 > Number(value)) {
    return message;
  }

  return undefined;
};

export default isNonNegativeNumber;
